module.exports = __webpack_public_path__ + "static/media/lds-logo_id.69be3d8f.svg";